"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Select = void 0;
var react_1 = __importStar(require("react"));
var SelectSearchInput_1 = require("./SelectSearchInput");
var FocusHelper_1 = require("./FocusHelper");
var SelectComponents_1 = require("./SelectComponents");
var SelectUtils_1 = require("./SelectUtils");
var useSelect_1 = require("./useSelect");
var Panel_1 = require("../Panel");
var Loader_1 = require("../Loader");
var Select = function (props) {
    var _a, _b;
    var components = __assign(__assign({}, SelectComponents_1.defaultSelectComponents), props.components);
    var _c = useSelect_1.useSelect(props), open = _c.open, close = _c.close, isOpen = _c.isOpen, isFocussed = _c.isFocussed, setIsFocussed = _c.setIsFocussed, isSearching = _c.isSearching, searchQuery = _c.searchQuery, onSearchChange = _c.onSearchChange, highlightedOption = _c.highlightedOption, setHighlightedOption = _c.setHighlightedOption, selectedOptions = _c.selectedOptions, onSelect = _c.onSelect, onSelectAll = _c.onSelectAll, onClearSelection = _c.onClearSelection, options = _c.options, isAllSelected = _c.isAllSelected, onKeyDown = _c.onKeyDown, setHighlightedEl = _c.setHighlightedEl, setSearchableInputEl = _c.setSearchableInputEl;
    var inputValue = react_1.useMemo(function () { var _a; return selectedOptions.map(function (option) { return option.value; }).join((_a = props.valueDelimiter) !== null && _a !== void 0 ? _a : ","); }, [selectedOptions]);
    var Container = components.Container, Control = components.Control, Option = components.Option, OptionContainer = components.OptionContainer, Value = components.Value, ValueContainer = components.ValueContainer;
    // CONTROL EVENT HANDLING
    var _d = react_1.useState(), controlEl = _d[0], setControlEl = _d[1];
    var onControlMouseDown = function (e) {
        if (!isOpen) {
            open();
            e.preventDefault();
        }
        else if (!props.interactiveControl && !props.inlineSearch) {
            close();
        }
    };
    // SELECT STYLES
    var dropdownRef = react_1.useRef(null);
    var _e = react_1.useState(), controlWidth = _e[0], setControlWidth = _e[1];
    var _f = react_1.useState(false), calculatingWidth = _f[0], setCalculatingWidth = _f[1];
    // Work out the width of the select control based on the options pre-emptively
    react_1.useEffect(function () {
        if (!controlWidth && !calculatingWidth) {
            setCalculatingWidth(true);
        }
    }, [controlWidth, calculatingWidth]);
    react_1.useEffect(function () {
        var _a, _b;
        if (dropdownRef.current && calculatingWidth && !controlWidth) {
            // Get the width of the invisible dropdown
            var width = (_a = dropdownRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect().width;
            var modifier = (_b = props.widthModifier) !== null && _b !== void 0 ? _b : 32;
            /**
             * If the width of the invisible dropdown is larger than the width of the control as it is now, then set the
             * control width. Otherwise keep it as is.
             */
            setControlWidth(width + modifier);
            setCalculatingWidth(false);
        }
    }, [dropdownRef.current, calculatingWidth]);
    // RENDERING
    var renderOption = function (option, index) {
        var _a;
        var isHighlighted = option === highlightedOption;
        var isSelected = selectedOptions.some(function (selectedOption) { return selectedOption.value === option.value; });
        var ref = isHighlighted ? setHighlightedEl : undefined;
        if (isSelected && props.hideOptionOnSelection) {
            return null;
        }
        return (react_1.default.createElement(OptionContainer, { ref: ref, isHighlighted: isHighlighted, isDisabled: option.disabled, onClick: function (e) {
                e.preventDefault();
                onSelect(option);
            }, onMouseEnter: function () { return setHighlightedOption(option); }, key: "select-option-" + index + "-" + option.value },
            react_1.default.createElement(Option, { multiple: (_a = props.multiple) !== null && _a !== void 0 ? _a : false, option: option, isHighlighted: isHighlighted, isSelected: isSelected, isDisabled: option.disabled })));
    };
    var renderGroup = function (group) {
        // TODO Move into own component.
        // TODO also potentially move heading into its own component
        if (!group.options || group.options.length === 0) {
            return null;
        }
        return __spreadArray([
            react_1.default.createElement("p", { className: "c-dropdown__group" }, group.heading)
        ], group.options.map(renderOption));
    };
    var renderOptions = function () {
        var optionsToRender = options
            .map(function (option, index) {
            if ("options" in option) {
                return renderGroup(option);
            }
            else {
                return renderOption(option, index);
            }
        })
            .filter(function (option) { return option !== null; });
        if (optionsToRender.length === 0) {
            return (react_1.default.createElement("div", { className: "u-align-center u-pad-small u-color-light" }, props.noOptionsText || "No options available"));
        }
        return optionsToRender;
    };
    var classes = [
        props.fill && "+fill",
        (isFocussed || isOpen) && "+focus",
        props.className,
    ].filter(function (item) { return !!item; });
    var handleFocus = function () {
        setIsFocussed(true);
        if (props.openOnFocus) {
            open();
        }
    };
    return (react_1.default.createElement(Container, null,
        react_1.default.createElement(Control, { ref: setControlEl, onMouseDown: onControlMouseDown, className: classes.join(" "), style: props.fill ? undefined : { width: controlWidth }, onKeyDown: onKeyDown },
            react_1.default.createElement("div", { className: "l-app +x +gap-0" },
                react_1.default.createElement("div", { className: "l-app__item +middle" },
                    react_1.default.createElement(ValueContainer, { className: "u-flex u-flex-wrap u-width-100pc" },
                        (!props.searchable || !isOpen) && !props.inlineSearch && (react_1.default.createElement(FocusHelper_1.FocusHelper, { ref: setSearchableInputEl, onBlur: function () { return setIsFocussed(false); }, onFocus: handleFocus })),
                        selectedOptions.length === 0 &&
                            (props.inlineSearch ? searchQuery.length === 0 : true) ? (react_1.default.createElement("span", { className: "u-color-light", style: { pointerEvents: "none" } }, props.placeholderText || "Select an item")) : (selectedOptions.map(function (option, index) { return (react_1.default.createElement(Value, __assign({}, props.selectValueProps, { option: option, onOptionSelect: onSelect, className: "c-dropdown__selected-option", key: "select-value-" + index + "-" + option.value }), SelectUtils_1.formatOption(option))); })),
                        props.inlineSearch && (react_1.default.createElement("input", { ref: setSearchableInputEl, tabIndex: 0, onChange: onSearchChange, onFocus: handleFocus, value: searchQuery, size: searchQuery.length || 1, type: "text", className: "c-input", style: {
                                background: 0,
                                border: 0,
                                fontSize: "inherit",
                                marginLeft: "5px",
                            } })))),
                !props.hideLoader && (react_1.default.createElement("div", { className: "l-app__item +end" }, isSearching && react_1.default.createElement(Loader_1.Loader, null))))),
        react_1.default.createElement(Panel_1.Panel, { isOpen: isOpen || calculatingWidth, anchorElement: controlEl, onRequestClose: function () { return close(); }, anchorElementClickable: props.interactiveControl, disableXSnapping: true, 
            // Don't control panel size if the width is being calculated
            panelSize: { width: calculatingWidth ? "auto" : "matchAnchor", height: "auto" }, 
            // Allow clicks elsewhere on the screen while calculating the width of the control
            preventDismissByClickAway: calculatingWidth, onKeyDown: onKeyDown },
            react_1.default.createElement("div", __assign({}, props.selectionComponentProps, { className: "c-dropdown u-width-100pc u-pos-static u-max-height-100pc u-overflow-auto " + ((_b = (_a = props.selectionComponentProps) === null || _a === void 0 ? void 0 : _a.className) !== null && _b !== void 0 ? _b : ""), 
                // Hide the dropdown while calculating the width of the control
                style: calculatingWidth ? { height: 0, visibility: "hidden" } : undefined, ref: dropdownRef }),
                ((props.searchable && !props.inlineSearch) ||
                    (props.canSelectAll && props.multiple)) && (react_1.default.createElement("div", { className: "c-dropdown__header" },
                    props.searchable && !props.inlineSearch && (react_1.default.createElement(SelectSearchInput_1.SelectSearchInput, { ref: setSearchableInputEl, onChange: onSearchChange, value: searchQuery, className: "c-input +fill +text", placeholder: "Search" })),
                    props.canSelectAll && props.multiple && (react_1.default.createElement("label", { className: "c-label u-font-regular" },
                        react_1.default.createElement("input", { className: "c-input", type: "checkbox", onChange: onSelectAll, checked: isAllSelected }),
                        "Select All")))),
                react_1.default.createElement("ul", { className: "c-dropdown__body", onMouseLeave: function () { return setHighlightedOption(undefined); } }, renderOptions()),
                selectedOptions.length > 0 && props.clearable && (react_1.default.createElement("div", { className: "c-dropdown__footer" },
                    react_1.default.createElement("button", { className: "c-button +text", onClick: onClearSelection }, "Clear selection"))))),
        props.name && react_1.default.createElement("input", { name: props.name, type: "hidden", value: inputValue })));
};
exports.Select = Select;
exports.Select.displayName = "Select";
//# sourceMappingURL=Select.js.map